//#region frontend/islands/product-media-gallery.js
var ProductMediaGallery = class extends HTMLElement {
	connectedCallback() {
		const swiperEl = this.querySelector("swiper-container");
		const productMediaGalleryWrapper = this.querySelector(".product-media-gallery-wrapper");
		const mediaIndexMap = {};
		const variantToSlideIndex = {};
		Array.from(swiperEl.querySelectorAll("swiper-slide")).forEach((s, i) => {
			const realIndex = s.hasAttribute("data-swiper-slide-index") ? parseInt(s.dataset.swiperSlideIndex, 10) : i;
			mediaIndexMap[s.dataset.mediaId] = realIndex;
			if (s.dataset.variantIds) s.dataset.variantIds.split(",").forEach((id) => {
				if (id) variantToSlideIndex[id] = realIndex;
			});
		});
		const thumbsEl = this.querySelector("#" + swiperEl.getAttribute("thumbs-swiper")?.replace("#", ""));
		productMediaGalleryWrapper.style.opacity = "0";
		const revealWhenReady = () => {
			if (swiperEl.swiper) {
				requestAnimationFrame(() => {
					productMediaGalleryWrapper.style.opacity = "100";
				});
				if (thumbsEl) swiperEl.swiper.on("realIndexChange", () => {
					const idx = swiperEl.swiper.realIndex;
					requestAnimationFrame(() => {
						thumbsEl?.swiper?.slideToLoop(idx, 300, false);
					});
				});
			} else requestAnimationFrame(revealWhenReady);
		};
		requestAnimationFrame(revealWhenReady);
		const getSlideIndex = (variantId, mediaId) => {
			const byVariant = variantToSlideIndex[String(variantId)];
			if (byVariant !== void 0) return byVariant;
			return mediaIndexMap[mediaId] ?? mediaIndexMap[mediaId?.toString()];
		};
		this._onVariantChange = (event) => {
			const variant = event.detail.variant;
			if (!variant?.id) return;
			const mediaId = variant?.featured_media?.id ?? variant?.featured_image?.id;
			const index = getSlideIndex(variant.id, mediaId);
			if (index !== void 0) this.slideWhenReady(swiperEl, thumbsEl, index, true);
		};
		document.addEventListener("recipe:change", this._onVariantChange);
		this._onVariantInput = (e) => {
			if (e.target.name !== "id") return;
			const variantId = e.target.value;
			if (!variantId) return;
			let index = variantToSlideIndex[String(variantId)];
			if (index === void 0) {
				const variant = (document.querySelector("variant-radios")?.getVariantData?.())?.find((v) => String(v.id) === String(variantId));
				const mediaId = variant?.featured_media?.id ?? variant?.featured_image?.id;
				if (mediaId != null) index = mediaIndexMap[mediaId];
			}
			if (index !== void 0) this.slideWhenReady(swiperEl, thumbsEl, index, true);
		};
		document.addEventListener("change", this._onVariantInput);
	}
	disconnectedCallback() {
		document.removeEventListener("recipe:change", this._onVariantChange);
		document.removeEventListener("change", this._onVariantInput);
	}
	slideWhenReady(el, thumbsEl, index, animate = false) {
		this._pendingSlideIndex = index;
		const attempt = () => {
			if (this._pendingSlideIndex !== index) return;
			if (el.swiper) {
				const speed = animate ? el.swiper.params.speed ?? 300 : 0;
				el.swiper.slideToLoop(index, speed, false);
				requestAnimationFrame(() => {
					if (this._pendingSlideIndex !== index) return;
					thumbsEl?.swiper?.slideToLoop(index, 300, false);
				});
			} else requestAnimationFrame(attempt);
		};
		requestAnimationFrame(attempt);
	}
};
customElements.define("product-media-gallery", ProductMediaGallery);
//#endregion
